var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 7.72266,
    r: 7.5,
    transform: "rotate(-90 8 7.72266)",
    fill: "#E8EAED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.222655C9.38317 0.222655 10.7394 0.605151 11.9187 1.32785C13.0981 2.05056 14.0546 3.08532 14.6825 4.31773C15.3105 5.55014 15.5854 6.93219 15.4769 8.3111C15.3684 9.69 14.8806 11.012 14.0676 12.131C13.2546 13.2501 12.148 14.1224 10.8701 14.6518C9.59225 15.1811 8.19288 15.3467 6.82674 15.1303C5.4606 14.9139 4.18091 14.324 3.12914 13.4257C2.07737 12.5274 1.2945 11.3558 0.867076 10.0403L8 7.72266L8 0.222655Z",
    fill: "#131314"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieIcon);
export default __webpack_public_path__ + "static/media/pie-icon.a56286f7245dc1dac1c88fe34cd6880b.svg";
export { ForwardRef as ReactComponent };